<div class="tablecontainer container my-2">
  <div class="row">
    <div class="col-12 ">
      <span class="title_header_bar">Create Suspension Schedule
      </span>
    </div>
  </div>
  <div class="card card_content">
    <div
      style="display:flex;align-items:center;justify-content:space-between;margin-bottom:22px;flex-wrap:wrap;gap:10px">
      <button class="btn btn-ghost btn-sm" routerLink="/suspensionDashboard">
        <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2">
          <line x1="19" y1="12" x2="5" y2="12" />
          <polyline points="12 19 5 12 12 5" />
        </svg>
        Back to Dashboard
      </button>
    </div>

    <form [formGroup]="suspensionForm">
      <div class="card" style="padding: 24px;">
        <div style="margin-bottom: 32px;">

          <!-- Debit order & suspension type -->
          <div class="form-section-title">
            <mat-icon color="primary">event</mat-icon>
            Debit order & suspension type
          </div>

          <div class="form-grid fg2">
            <mat-form-field appearance="fill">
              <mat-label>Debit Order</mat-label>
              <mat-select formControlName="debitOrder" required [disabled]="suspensionForm.value.manageSuspensionId!=0">
                <mat-option *ngFor="let date of debitDates" [value]="date.key">
                  {{ date.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div>
              <mat-form-field appearance="fill" hideRequiredMarker>
                <mat-label>Suspension Type</mat-label>
                <mat-select formControlName="processType">
                  <mat-option value=3>Suspension Process</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div>
              <app-month-year-picker formControlName="targetMonth" [minDate]="minDate" [maxDate]="targetMaxDate"
                label="Target Month">
              </app-month-year-picker>
            </div>
          </div>

          <!-- Execution Dates -->
          <div style="margin-bottom: 32px;margin-top: 2rem" *ngIf="shouldShowExecutionDatesBlock()">
            <div class="form-section-title">
              <mat-icon color="primary">schedule</mat-icon>
              Execution dates
            </div>

            <div class="info-box" style="margin-bottom: 16px;" *ngIf="!isViewMode">
              Add one or more execution dates. Records will be automatically <b>split evenly</b> across these dates.
            </div>

            <div style="display:flex; justify-content: flex-start; margin-bottom:16px;" *ngIf="!isViewMode">
              <div class="col-4" style=" padding-left:0px">
                <mat-form-field appearance="fill">
                  <mat-label>Add Execution Date</mat-label>
                  <input matInput [matDatepicker]="execPicker" #execDateInput type="text"
                    formControlName="suspensionDate" placeholder="mm/dd/yyyy" [min]="suspensionMinDate">
                  <mat-datepicker-toggle matSuffix [for]="execPicker"></mat-datepicker-toggle>
                  <mat-datepicker #execPicker></mat-datepicker>
                </mat-form-field>
              </div>

              <div class="col-5" style=" padding-left:0px">
                <button mat-stroked-button class="btn btn-primary addDate" color="primary" type="button"
                  (click)="addExecDate(execDateInput.value); execDateInput.value=''"
                  [disabled]="isNotificationSent || isViewMode">
                  <mat-icon>add</mat-icon>
                  Add Date
                </button>
              </div>
            </div>

            <div class="date-entries">
              <ng-container *ngIf="suspensionDates.length > 0; else emptyState">
                <div *ngFor="let date of suspensionDates; let i = index" class="de-row">
                  <div class="de-num">{{i + 1}}</div>

                  <div class="de-fields">
                    <div class="de-field">
                      <div class="de-label">Execution Date</div>
                      <div class="de-val">{{ date | date:'MM/dd/yyyy' }}</div>
                    </div>
                    <div class="de-field">
                      <div class="de-label">Batch Split</div>
                      <div class="de-val">
                        <span class="badge"
                          [ngClass]="{'badge-info': suspensionDates.length === 1, 'badge-split': suspensionDates.length > 1}">
                          {{ suspensionDates.length === 1 ? 'Single' : 'Split ' + (i + 1) + '/' + suspensionDates.length
                          }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <button mat-icon-button color="warn" class="de-remove" (click)="removeExecDate(i)"
                    *ngIf="!isNotificationSent && !isViewMode">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </ng-container>

              <ng-template #emptyState>
                <mat-card style="padding:10px; border: 1px dashed #ddd;">
                  <p>No execution dates added yet. At least one required.</p>
                </mat-card>
              </ng-template>

            </div>
          </div>

          <!-- Pre-suspension notification -->

          <div style="margin-bottom: 24px; margin-top: 2rem" *ngIf="shouldShowNotificationBlock()">
            <div class="form-section-title">
              <mat-icon color="primary">notifications</mat-icon>
              Pre-suspension notification
            </div>

            <div class="form-grid fg2">
              <mat-form-field appearance="fill" hideRequiredMarker>
                <mat-label>Notification Date</mat-label>
                <input matInput [matDatepicker]="notificationPicker" type="text" formControlName="notificationDate"
                  [min]="notificationMinDate" [max]="notificationMaxDate" placeholder="mm/dd/yyyy" required>
                <mat-datepicker-toggle matSuffix [for]="notificationPicker"></mat-datepicker-toggle>
                <mat-datepicker #notificationPicker></mat-datepicker>
              </mat-form-field>

              <mat-form-field appearance="fill" hideRequiredMarker>
                <mat-label>Notification Preference</mat-label>
                <mat-select formControlName="channel" required [disabled]="true">
                  <mat-option *ngFor="let type of notificationPreferences" [value]="type.key">
                    {{ type.value }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="info-box" style="margin-top:14px" *ngIf="getDaysBefore()">
              Notification will be sent <b style="color:#7200c8">{{getDaysBefore()}}</b> before the first suspension
              run.
            </div>
          </div>

          <div style="display:flex;justify-content:flex-end;gap:12px;">
            <button mat-button class="btn btn-secondary" routerLink="/suspensionDashboard"
              style="padding-top:5px; margin-top: 2px;">Cancel</button>
            <button mat-raised-button color="primary" class="btn btn-primary" type="button" (click)="saveSchedule()"
              [disabled]="!suspensionForm.valid || isViewMode" *ngIf="!isNotificationSent && !isViewMode">
              Confirm & Create Schedule
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>